
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="自定义图标" fileName="custom-icon.md" />
        <p>filterIcon 回调函数，支持返回自定义的 icon。此处使用了内置的 <code>&lt;ve-icon name=&quot;search&quot; /&gt;</code> 图标，你也可以其他图标库</p>
<demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;ve-table :max-height=&quot;300&quot; :fixed-header=&quot;true&quot; :columns=&quot;columns&quot; :table-data=&quot;tableData&quot; /&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                searchValue: &quot;&quot;,
                columns: [
                    {
                        field: &quot;name&quot;,
                        key: &quot;a&quot;,
                        title: &quot;Name&quot;,
                        align: &quot;left&quot;,
                        width: &quot;15%&quot;,
                        // filter custom
                        filterCustom: {
                            defaultVisible: false,
                            render: ({ showFn, closeFn }, h) =&gt; {
                                return (
                                    &lt;div class=&quot;custom-name-filter&quot;&gt;
                                        &lt;input
                                            value={this.searchValue}
                                            on-input={(e) =&gt; (this.searchValue = e.target.value)}
                                            placeholder=&quot;Search name&quot;
                                        /&gt;
                                        &lt;div class=&quot;custom-name-filter-operation&quot;&gt;
                                            &lt;span
                                                class=&quot;name-filter-cancel&quot;
                                                on-click={() =&gt; this.searchCancel(closeFn)}
                                            &gt;
                                                取消
                                            &lt;/span&gt;
                                            &lt;span
                                                class=&quot;name-filter-confirm&quot;
                                                on-click={() =&gt; this.searchConfirm(closeFn)}
                                            &gt;
                                                查询
                                            &lt;/span&gt;
                                        &lt;/div&gt;
                                    &lt;/div&gt;
                                );
                            },
                            // custom filter icon
                            filterIcon: () =&gt; {
                                return &lt;ve-icon name=&quot;search&quot; /&gt;;
                            },
                        },
                    },
                    {
                        field: &quot;date&quot;,
                        key: &quot;b&quot;,
                        title: &quot;Date&quot;,
                        align: &quot;left&quot;,
                        width: &quot;15%&quot;,
                    },
                    {
                        field: &quot;hobby&quot;,
                        key: &quot;c&quot;,
                        title: &quot;Hobby&quot;,
                        align: &quot;center&quot;,
                        width: &quot;30%&quot;,
                    },
                    {
                        field: &quot;address&quot;,
                        key: &quot;d&quot;,
                        title: &quot;Address&quot;,
                        align: &quot;left&quot;,
                        width: &quot;40%&quot;,
                    },
                ],
                // real table data
                tableData: [],
                // source data
                sourceData: [
                    {
                        name: &quot;John&quot;,
                        date: &quot;1900-05-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Shanghai&quot;,
                        rowKey: 0,
                    },
                    {
                        name: &quot;Dickerson&quot;,
                        date: &quot;1910-06-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Beijing&quot;,
                        rowKey: 1,
                    },
                    {
                        name: &quot;Larsen&quot;,
                        date: &quot;2000-07-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Chongqing&quot;,
                        rowKey: 2,
                    },
                    {
                        name: &quot;Geneva&quot;,
                        date: &quot;2010-08-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Xiamen&quot;,
                        rowKey: 3,
                    },
                    {
                        name: &quot;Jami&quot;,
                        date: &quot;2020-09-20&quot;,
                        hobby: &quot;coding and coding repeat&quot;,
                        address: &quot;No.1 Century Avenue, Shenzhen&quot;,
                        rowKey: 4,
                    },
                ],
            };
        },
        methods: {
            // search
            search() {
                const searchValue = this.searchValue;
                this.tableData = this.sourceData.filter(
                    (x) =&gt;
                        !searchValue.length ||
                        x.name.toLowerCase().includes(searchValue.toLowerCase()),
                );
            },

            // search cancel
            searchCancel(closeFn) {
                closeFn();
            },

            // search cancel
            searchConfirm(closeFn) {
                this.search();
                closeFn();
            },
        },
        created() {
            this.tableData = this.sourceData.slice(0);
        },
    };
&lt;/script&gt;

&lt;style&gt;
    .custom-name-filter {
        padding: 10px;

        .custom-name-filter-operation {
            cursor: pointer;

            margin: 10px 10px 0px 0;
            .name-filter-cancel,
            .name-filter-confirm {
                &amp;:hover {
                    color: #1890ff;
                }
            }

            .name-filter-cancel {
                float: left;
            }

            .name-filter-confirm {
                float: right;
            }
        }
    }
&lt;/style&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('ve-table',{attrs:{"max-height":300,"fixed-header":true,"columns":_vm.columns,"table-data":_vm.tableData}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                searchValue: "",
                columns: [
                    {
                        field: "name",
                        key: "a",
                        title: "Name",
                        align: "left",
                        width: "15%",
                        // filter custom
                        filterCustom: {
                            defaultVisible: false,
                            render: ({ showFn, closeFn }, h) => {
                                return (
                                    <div class="custom-name-filter">
                                        <input
                                            value={this.searchValue}
                                            on-input={(e) => (this.searchValue = e.target.value)}
                                            placeholder="Search name"
                                        />
                                        <div class="custom-name-filter-operation">
                                            <span
                                                class="name-filter-cancel"
                                                on-click={() => this.searchCancel(closeFn)}
                                            >
                                                取消
                                            </span>
                                            <span
                                                class="name-filter-confirm"
                                                on-click={() => this.searchConfirm(closeFn)}
                                            >
                                                查询
                                            </span>
                                        </div>
                                    </div>
                                );
                            },
                            // custom filter icon
                            filterIcon: () => {
                                return <ve-icon name="search" />;
                            },
                        },
                    },
                    {
                        field: "date",
                        key: "b",
                        title: "Date",
                        align: "left",
                        width: "15%",
                    },
                    {
                        field: "hobby",
                        key: "c",
                        title: "Hobby",
                        align: "center",
                        width: "30%",
                    },
                    {
                        field: "address",
                        key: "d",
                        title: "Address",
                        align: "left",
                        width: "40%",
                    },
                ],
                // real table data
                tableData: [],
                // source data
                sourceData: [
                    {
                        name: "John",
                        date: "1900-05-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Shanghai",
                        rowKey: 0,
                    },
                    {
                        name: "Dickerson",
                        date: "1910-06-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Beijing",
                        rowKey: 1,
                    },
                    {
                        name: "Larsen",
                        date: "2000-07-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Chongqing",
                        rowKey: 2,
                    },
                    {
                        name: "Geneva",
                        date: "2010-08-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Xiamen",
                        rowKey: 3,
                    },
                    {
                        name: "Jami",
                        date: "2020-09-20",
                        hobby: "coding and coding repeat",
                        address: "No.1 Century Avenue, Shenzhen",
                        rowKey: 4,
                    },
                ],
            };
        },
        methods: {
            // search
            search() {
                const searchValue = this.searchValue;
                this.tableData = this.sourceData.filter(
                    (x) =>
                        !searchValue.length ||
                        x.name.toLowerCase().includes(searchValue.toLowerCase()),
                );
            },

            // search cancel
            searchCancel(closeFn) {
                closeFn();
            },

            // search cancel
            searchConfirm(closeFn) {
                this.search();
                closeFn();
            },
        },
        created() {
            this.tableData = this.sourceData.slice(0);
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      .custom-name-filter {
        padding: 10px;

        .custom-name-filter-operation {
            cursor: pointer;

            margin: 10px 10px 0px 0;
            .name-filter-cancel,
            .name-filter-confirm {
                &:hover {
                    color: #1890ff;
                }
            }

            .name-filter-cancel {
                float: left;
            }

            .name-filter-confirm {
                float: right;
            }
        }
    }
    </style>
  